export function isInputElement(target: HTMLElement): boolean {
    return (
        target.tagName === "TEXTAREA" ||
        target.tagName === "SELECT" ||
        target.isContentEditable === true ||
        (target.tagName === "INPUT" && (target as HTMLInputElement).type !== "range")
    );
}
